import { useEffect, useState } from "react";
import {
  closeFilterActions,
  closePreSelect,
  currentTabHandler,
  handleCustomSearchText,
} from "../../../store/slices/Project/ProjectSlice";
import { useDispatch, useSelector } from "react-redux";

export const useTab = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("activeTab");
  const [isChecked, setIsChecked] = useState(false);
  const [activeTabLeft, setActiveTabLeft] = useState("");
  const [activeTabWidth, setActiveTabWidth] = useState("");
  const { sections, currentTab } = useSelector((state) => state.project);

  const handleClickTab = (e, tab) => {
    const callback = () => {
      setActiveTab(tab);
      setActiveTabLeft(e.target.offsetLeft);
      setActiveTabWidth(e.target.offsetWidth);
    };
    dispatch(currentTabHandler({ tab: tab, callback: callback }));
    dispatch(closeFilterActions());
    dispatch(closePreSelect());
    dispatch(handleCustomSearchText(""));
  };

  useEffect(() => {
    
    let activeTabSelect = document.querySelectorAll(".tabActive");
    // setActiveTabLeft(activeTabSelect[0]?.offsetLeft);
    // setActiveTabWidth(activeTabSelect[0]?.offsetWidth);
    const callback = () => {
      setActiveTab(currentTab??"activeTab");
      setActiveTabLeft(activeTabSelect[0]?.offsetLeft??0);
      setActiveTabWidth(activeTabSelect[0]?.offsetWidth);
    };
    dispatch(currentTabHandler({ tab: currentTab??"activeTab", callback: callback }));
  }, []);

  return {
    activeTab,
    isChecked,
    activeTabLeft,
    activeTabWidth,
    setActiveTab,
    setIsChecked,
    setActiveTabLeft,
    setActiveTabWidth,
    handleClickTab,
    currentTab,
  };
};
